<template>
  <v-list
    class="l-admin-info"
    :class="{'l-admin-info--min': minDrawer}"
  >
    <v-list-tile avatar>
      <v-list-tile-avatar size="40">
        <img
          v-if="!!admin.profilePicture"
          :src="admin.profilePicture"
          alt="Admin"
        >
        <v-icon
          x-large
          color="red darken-2"
        >account_circle</v-icon>
      </v-list-tile-avatar>
      <div>{{ admin.name }}</div>
      <v-list-tile-content>
        <v-list-tile-title class="subheading font-weight-medium">{{ admin.name }}</v-list-tile-title>
        <v-list-tile-sub-title class="grey--text text--darken-1">{{ admin.email }}</v-list-tile-sub-title>
        <v-list-tile-sub-title
          v-if="admin.groups.length > 0"
          class="grey--text text--lighten-1"
        >
          <v-tooltip bottom>
            <span>Assigned groups: {{ groupNames }}</span>
            <span
              slot="activator"
            >{{ groupNames }}</span>
          </v-tooltip>
        </v-list-tile-sub-title>
        <v-list-tile-sub-title
          v-if="admin.licenses.length > 1"
          class="grey--text text--lighten-1"
        >
          <v-select
            id="license"
            :items="licenses"
            :value="admin.selectedLicense"
            item-text="name"
            item-value="value"
            label="License"
            @change="onChangeLicenseClick"
          />
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-btn
          class="navigation-toggle"
          icon
          @click.stop="$emit('update:minDrawer', !minDrawer)"
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
    <v-divider class="grey lighten-3" />
  </v-list>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PortalApi from '@/services/Api/PortalApi'

  export default {
    name: 'NavigationMenuAdminInfo',
    props: {
      minDrawer: {
        required: true,
        type: Boolean
      }
    },
    data () {
      return {
        updateLicense: new ApiRequest(PortalApi.selectLicense)
      }
    },
    computed: {
      ...mapGetters('admin', ['admin']),
      groupNames () {
        return this.admin.groups.map(({ name }) => name).join(', ')
      },
      licenses () {
        const licenses = this.admin.licenses.join(', ')
        return [
          { name: licenses, value: null },
          ...this.admin.licenses
        ]
      }
    },
    methods: {
      onChangeLicenseClick (license) {
        this.updateLicense
          .execute(license)
          .then(() => location.reload())
          .catch(() => {})
      }
    }
  }
</script>

<style>
  .l-admin-info {
    padding-top: 23px;
    padding-bottom: 0;
  }

  .l-admin-info .v-list__tile {
    height: auto;
    padding-bottom: 25px;
  }

  .l-admin-info .v-list__tile__avatar {
    align-self: flex-start;
    margin-top: 2px;
  }

  .l-admin-info .v-list__tile__avatar + div {
    display: none;
    text-align: center;
    font-size: 13px;
    padding: 8px 5px 0 5px;
  }

  .l-admin-info .v-list__tile__sub-title {
    font-size: 13px;
    font-weight: 400;
  }

  .l-admin-info--min .v-list__tile {
    flex-flow: column;
    height: auto;
    padding-right: 0;
    padding-left: 0;
  }

  .l-admin-info--min .v-list__tile__content,
  .l-admin-info--min .v-list__tile:after {
    display: none;
  }

  .l-admin-info--min .v-list__tile__avatar {
    margin-top: 0;
  }

  .l-admin-info--min .v-list__tile__avatar + div {
    display: block;
  }
</style>
